<header id="iconHeader" class="dsDialog_header">
  <h2>{{ dialogTitle }}</h2>
</header>
<section class="dsDialog_content rsvpDialogBody">
  <p>{{ dialogMessage }}</p>
</section>
<footer class="dsDialog_actions">
  <button class="dsButton" (click)="onButtonClick('Cancel')">
    {{ 'MODULES.COMMON.CANCEL' | transloco }}
  </button>
  <button class="dsButton dsButton-primary" (click)="onButtonClick('Ok')">
    {{ okButtonText }}
  </button>
</footer>
